import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Dropdown from "components/Dropdown";
import Input from "components/Input";
import PhoneNumberInput from "components/PhoneNumberInput";
import Button from "components/Button";
import ModalResetPasswordSent from 'screens/ModalResetPasswordSent';
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { FORGOT_PASSWORD } from "graphql/service";
import { Container, ContentContainer } from "./styles";
import Logo from "assets/Logo.png";
import { debouncedErrorMessage } from "utils/messageUtil";

const ForgotPassword = () => {
  
  const options = [
    { value: "EMAIL", label: "Email" },
    { value: "SMS", label: "Phone" },
  ];

  const [method, setMethod] = useState("");
  const [dropdownError, setDropdownError] = useState(false);
  const [methodChosen, setMethodChosen] = useState(false);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberValidity, setPhoneNumberValidity] = useState(true);
  const [phoneNumberError, setPhoneNumberError] = useState(false);

  const [sentIsOpen, setSentIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);

  const [forgotPassword, { loading }] = useMutation(FORGOT_PASSWORD, {
    onCompleted: (data) => {
      if (data.forgotPasswordStaff) {
        setSentIsOpen(true);
        setFailedIsOpen(false);
      } else {
        setFailedIsOpen(true);
        setSentIsOpen(false);
      }
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(
            error.graphQLErrors[0]?.extensions?.exception
          );
        }
        debouncedErrorMessage(content);
      }
    },
  });

  const handleContinue = () => {
    if (method === "") {
      setDropdownError(true);
      return;
    }
    setMethodChosen(true);
  };

  const handleReset = () => {
    let error = false;
    if (method === "EMAIL") {
      if (email.trim() === "") {
        setEmailError(true);
        error = true;
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
        setEmailError(true);
        error = true;
      }
    } else if (method === "SMS") {
      if (phoneNumber.trim() === "") {
        error = true;
      } else if (!phoneNumberValidity) {
        setPhoneNumberError(true);
        error = true;
      }
    }
    if (error) return;
    forgotPassword({
      variables: {
        input: {
          login: method === "EMAIL" ? email : phoneNumber,
          channel: method,
        },
      },
    });
  };

  return (
    <Container>
      <Helmet>
        <title>Login - Rook Hotel PMS</title>
        <meta name="description" content="Login - Rook Hotel PMS" />
      </Helmet>
      <ContentContainer>
        <img src={Logo} alt="Logo" />
        <div className="brand">
          <span className="rook">ROOK </span>
          <span className="hotel">HOTEL</span>
        </div>
        <div className="title">Forgot Password</div>
        <div className="password">
          {!methodChosen ? (
            <Dropdown
              mainPage
              required
              options={options}
              title="RETRIEVE METHOD"
              error={dropdownError}
              value={options.find((option) => option.value === method)?.label}
              onChange={(e) => {
                setMethod(e);
                setDropdownError(false);
              }}
              additionalstyle={`
              width: 100%;
              margin-top: 24px;
            `}
            />
          ) : method === "EMAIL" ? (
            <Input
              title={"EMAIL"}
              required
              error={emailError}
              errorMessage={`Please enter a valid email.`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              additionalstyle={`
              width: 100%;
              margin-top: 24px;
            `}
            />
          ) : (
            <PhoneNumberInput
              mainPage
              title="PHONE"
              error={phoneNumberError}
              errorMessage={`Please enter a valid phone number.`}
              value={phoneNumber}
              onChangeNumber={(number) => setPhoneNumber(number)}
              onPhoneValidityChange={(isValid) =>
                setPhoneNumberValidity(isValid)
              }
              onBlur={() => {
                setPhoneNumberError(
                  !phoneNumberValidity && phoneNumber.length > 0
                );
              }}
              additionalstyle={`
              width: 100%;
              margin-top: 24px;
            `}
            />
          )}
        </div>
        {!methodChosen ? (
          <Button
            mainPage
            onClick={handleContinue}
            additionalstyle={`
            width: 97px;
            margin-top: 24px;
          `}
          >
            Continue
          </Button>
        ) : (
          <Button
            mainPage
            onClick={handleReset}
            data-loading={loading}
            additionalstyle={`
            width: 79px;
            margin-top: 24px;
          `}
          >
            {loading ? null : "Reset"}
          </Button>
        )}
      </ContentContainer>
      <ModalResetPasswordSent
        isOpen={sentIsOpen}
        setIsOpen={setSentIsOpen}
        type={method}
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        type="resetPassword"
        loading={loading}
        retryFunction={handleReset}
      />
    </Container>
  );
};

export default ForgotPassword;
